import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {TrackingService} from "../services/tracking.service";
import {groupDocuments, parseTourId, Tour} from "../interfaces/tour.model";

export interface TourDetailsData {
  tour: Tour;
  daysBack: number;
}

@Component({
  selector: 'app-tour-details-dialog',
  imports: [DatePipe, MatDialogModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
  templateUrl: './tour-details-dialog.component.html',
  styleUrl: './tour-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourDetailsDialogComponent {
  private readonly data = inject<TourDetailsData>(MAT_DIALOG_DATA);
  private readonly trackingService = inject(TrackingService);

  readonly tour = this.data.tour;
  readonly info = parseTourId(this.tour.tour_id, this.data.daysBack);
  readonly documents = groupDocuments(this.tour.package);
  readonly totalLines = this.documents.reduce((sum, d) => sum + d.lines.length, 0);
  readonly query = signal('');

  readonly visible = computed(() => {
    const raw = this.query().trim();
    if (!raw) return this.documents;
    const q = raw.toLowerCase();
    return this.documents
    .map(d => ({
      ...d,
      lines: d.lines.filter(l => l.article_code.startsWith(raw) || l.article_name.toLowerCase().includes(q)),
    }))
    .filter(d => d.lines.length > 0);
  });

  download(docNo: number): void {
    this.trackingService.downloadInvoice(docNo, this.tour.tour_id);
  }
}
